import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  TenantConnectionDto,
  TenantConnectionReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import TenantConnectionInline, { TenantConnectionInlineProps } from "./TenantConnectionInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: TenantConnectionDto | TenantConnectionReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<TenantConnectionInlineProps>;
}

export default function TenantConnectionLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.TenantConnectionRead]}
      to={ROUTE_PATH.TENANT_CONNECTION_VIEW(entity?.id || entityId || "")}
      content={<TenantConnectionInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
